// extracted by mini-css-extract-plugin
export default {"loading":"StudentInfoCalendarPanel_loading__9TPEN"};